import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { LoggerProvider } from '@shared';
import { CaseFormRepository } from '../../../infrastructure/repositories/case-form.repository';
import { CaseFormState } from '../../states/case-form.state';
import { PublishDraftQuery } from './publish-draft.query';

/**
 * Publish Draft Use Case
 * Publishes the draft version of a case form
 */
@Injectable({ providedIn: 'root' })
export class PublishDraftUseCase {
  private readonly _repository = inject(CaseFormRepository);
  private readonly _state = inject(CaseFormState);
  private readonly _logger = inject(LoggerProvider).createScoped('PublishDraftUseCase');

  public execute(query: PublishDraftQuery): Observable<{ versionId: string }> {
    this._state.setLoadingCaseForm(true);
    this._state.clearErrorCaseForms();

    return this._repository.publishDraft(query.formId).pipe(
      tap((result) => {
        this._logger.info('Published draft version', { versionId: result.versionId });
        this._state.updateCaseFormStatus(query.formId, 'Published');
      }),
      catchError((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          `Failed to publish draft for form ${query.formId}`;
        this._state.setErrorCaseForms(errorMessage);
        return throwError(() => error);
      }),
      finalize(() => this._state.setLoadingCaseForm(false))
    );
  }
}
